module.exports = {
    resourcesTitle: 'Resources',
    marketreports: 'Market Reports',
    appanalysis: 'APP Analysis',
    competitoranalysis: 'Competitor Analysis',
    appDataMarket: 'Store Data Search',
    pleaseInputPKG: 'please input app id',
    pleaseSelectYourPlatform: 'please select your platform',
    pleasaEnterFiltersCountry: 'Pleasa enter Filters country',
    countryOptional: 'Country(Optional)',
    Local:'Local',
    Aggregator:'Aggregator',
    Programmatic:'Programmatic',
    ADN:'ADN',
    KOL:'KOL',
    Service:'Service',
    MKT:'MKT',
    AggregatorS:'Aggregator MKT',
    Report:'Report',
}



// WEBPACK FOOTER //
// ./src/i18n/modules/resources/en.js